// Widgets components
const WidgetsCategoryList = () => import('@/views/widgets/WidgetsCategoryList')
const WidgetsCategoryForm = () => import('@/views/widgets/WidgetsCategoryForm')
const WidgetsList = () => import('@/views/widgets/WidgetsList')
const WidgetsForm = () => import('@/views/widgets/WidgetsForm')

// User components
const UserRoleList = () => import('@/views/users/UserRoleList')
const UserRoleForm = () => import('@/views/users/UserRoleForm')
const UsersList = () => import('@/views/users/UserList')
const UsersForm = () => import('@/views/users/UserForm')
const UserADDepartmentList = () => import('@/views/users/UserADDepartmentList')
const UserADDepartmentForm = () => import('@/views/users/UserADDepartmentForm')

const menuSetting = [
  {
    path: 'category',
    name: 'Widgets Category',
    component: WidgetsCategoryList,
  },
  {
    path: 'category/add',
    name: 'Widgets Category Add',
    component: WidgetsCategoryForm
  },
  {
    path: 'category/edit/:id',
    name: 'Widgets Category Edit',
    component: WidgetsCategoryForm,
  },
  {
    path: 'widgets',
    name: 'Widgets List',
    component: WidgetsList
  },
  {
    path: 'widgets/add',
    name: 'Widgets List Add',
    component: WidgetsForm,
    props: true
  },
  {
    path: 'widgets/edit/:id',
    name: 'Widgets List Edit',
    component: WidgetsForm
  },
  {
    path: "users/department_ad",
    name: "Department AD Role",
    component: UserADDepartmentList
  },
  {
    path: "users/department_ad/edit/:id",
    name: "Department AD Edit Role",
    component: UserADDepartmentForm
  },
  {
    path: "users/group",
    name: "Users Group",
    component: UserRoleList
  },
  {
    path: 'users/group/add',
    name: 'User Group Add',
    component: UserRoleForm
  },
  {
    path: 'users/group/edit/:id',
    name: 'User Group Edit',
    component: UserRoleForm
  },
  {
    path: "users",
    name: "Users List",
    component: UsersList
  },
  {
    path: "users/add",
    name: "Users Add",
    component: UsersForm
  },
  {
    path: "users/edit/:id",
    name: "Users Edit",
    component: UsersForm
  }
]

const routerSetting = menuSetting.map(data => {
  const { path, title, component, children } = data

  return {
    path: path,
    name: title,
    component: component,
    meta: {
      title: title,
      requiresAuth: true,
      breadcrumb: title
    },
    children: children
  }
})

export default routerSetting
